<template>
  <template v-if="dossier[column.field] && dossier[column.field] !== '#######'">
    <Popover>
      <Float auto-placement :offset="2" :portal="true" composable>
        <FloatReference>
          <PopoverButton
            as="div"
            class="flex cursor-pointer items-center justify-center"
          >
            <BaseButton
              :color="
                column.field === 'dossier#properties#internal_notes'
                  ? 'primary'
                  : column.field === 'logged_activities_dashboard'
                    ? undefined
                    : 'warning'
              "
              :theme-color="
                column.field === 'logged_activities_dashboard'
                  ? 'bg-purple-500 border-purple-500 text-white'
                  : undefined
              "
              :icon="
                column.field === 'logged_activities_dashboard'
                  ? 'font-awesome'
                  : 'circle-info'
              "
              size="extra-small"
            />
          </PopoverButton>
        </FloatReference>
        <PopoverOverlay class="fixed inset-0 z-100 bg-black opacity-30" />
        <FloatContent>
          <PopoverPanel
            class="z-100 w-80 rounded-md border border-gray-200 bg-white p-2 shadow-2xl"
          >
            <div
              class="flex max-h-82 shrink-0 flex-col flex-wrap gap-2 text-left"
            >
              <h1 class="capitalize-first shrink-0 text-base font-bold">
                {{ modalTitle }} :
              </h1>
              <div class="min-h-0 flex-1 overflow-y-auto text-xs font-medium">
                <div
                  class="whitespace-pre-wrap"
                  v-html="dossier[column.field]"
                ></div>
              </div>
            </div>
          </PopoverPanel>
        </FloatContent>
      </Float>
    </Popover>
  </template>
</template>
<script>
import {
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel
} from '@headlessui/vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { Float, FloatReference, FloatContent } from '@headlessui-float/vue'

export default {
  name: 'ModalComponent',
  components: {
    Float,
    FloatReference,
    FloatContent,
    BaseButton,
    Popover,
    PopoverButton,
    PopoverOverlay,
    PopoverPanel
  },
  props: {
    column: {
      type: [Array, Object],
      required: true
    },
    dossier: {},
    blockPlacement: {
      type: String,
      required: false,
      default: 'bottom'
    },
    linePlacement: {
      type: String,
      required: false,
      default: 'center'
    }
  },
  computed: {
    blockPlacementPopoverClass() {
      if (this.blockPlacement === 'top') {
        return '-translate-y-full top-0'
      }
      return ''
    },
    linePlacementArrowClass() {
      if (this.linePlacement === 'center') {
        return ''
      } else if (this.linePlacement === 'left') {
        return 'right-5'
      } else if (this.linePlacement === 'right') {
        return 'left-5'
      }
    },
    linePlacementPopoverClass() {
      if (this.linePlacement === 'center') {
        return 'transform -translate-x-1/2 left-1/2'
      } else if (this.linePlacement === 'left') {
        return 'transform -translate-x-5 right-0'
      } else if (this.linePlacement === 'right') {
        return 'transform left-0 translate-x-5'
      }
      return ''
    },
    modalTitle() {
      if (this.column.field === 'dossier#properties#internal_notes') {
        return this.$t('attributes.internal_notes')
      }
      if (this.column.field === 'logged_activities_dashboard') {
        return this.$t('global.consignations')
      }
      return this.$h.getLocalizedLabel(
        this.column.label,
        this.$i18n.locale,
        this.$t('global.particularities')
      )
    }
  }
}
</script>
